module.exports = __webpack_public_path__ + "img/antler.befcf287.svg";